<template>
  <div class="tile is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <h1 class="title has-text-centered">{{heading}}</h1>
        <button class="button is-small is-info" @click="show = !show">Show / Hide</button>
        <div v-if="show">
        <slot name="filter"></slot>
        <slot name="graph"></slot>
        <div class="table__wrapper">
          <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
            <thead>
              <th v-for="heading in headers" v-bind:key="heading">
                {{heading}}
              </th>
            </thead>
            <tbody>
              <tr v-for="row in tableData" v-bind:key="row.id">
                <td v-for="data in row" v-bind:key="data.id">{{data}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
        </div>
    </article>
  </div>
</template>
<script>
import Chart from 'vue-bulma-chartjs'
export default {
  props: ['heading', 'headers', 'tableData', 'total', 'defaultShow'],
  components: {
    Chart
  },
  data () {
    return {
      show: false,
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: false,
          labels: {
            fontColor: 'rgb(255, 99, 132)'
          }
        }
      }
    }
  },
  methods: {
  },
  created () {
    if (this.defaultShow) {
      this.show = true
    }
    // console.log('Edit Table Data is: ' + this.total)
  }
}
</script>
<style>
.table__wrapper {
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// embedded-data-graph.vue?36eaa714